import { Injectable } from '@angular/core';
import { ApiService } from "../api.service";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { LoadActivityModel } from "../../models/warehouse-edi/load-activity.model";
import { map } from "rxjs/operators";
import { LoadStatusModel } from "../../models/warehouse-edi/load-status.model";
import { decodeBase64 } from "../../utils/utils";

@Injectable({
  providedIn: 'root'
})
export class OperationService {

  constructor(private readonly apiService: ApiService) { }

  getLoadActitiviesByDate(date: number): Observable<LoadActivityModel[]> {
    return this.apiService
      .get<LoadActivityModel[]>(environment.operations.warehouseEdi.loadActivities + date)
      .pipe(map((response: any) => response.data));
  }

  getLoadActitiviesByMBL(MBL: string): Observable<LoadActivityModel[]> {
    return this.apiService
      .get<LoadActivityModel[]>(environment.operations.warehouseEdi.loadActivitiesByMbl + MBL)
      .pipe(map((response: any) => response.data));
  }

  getLoadStatusByDate(date: number): Observable<LoadStatusModel[]> {
    return this.apiService
      .get<LoadStatusModel[]>(environment.operations.warehouseEdi.loadStatus + date)
      .pipe(map((response: any) => response.data));
  }

  getLoadStatusByMBL(MBL: string): Observable<LoadStatusModel[]> {
    return this.apiService
      .get<LoadStatusModel[]>(environment.operations.warehouseEdi.loadStatusByMbl + MBL)
      .pipe(map((response: any) => response.data));
  }

  getXmlEdiFile(mbl: number): Observable<any> {
    return this.apiService
      .get<any>(environment.operations.xmlEdiFile + mbl)
      .pipe(map((response: any) => decodeBase64(response.data)));
  }

  reBuildEdiFile(loadId: number, eventType: number) {
    return this.apiService.post<any>(environment.operations.reBuildEdiFile, { LoadId: loadId, EventType: eventType });
  }

  reSendEdiFile(activityId: number) {
    return this.apiService.post<any>(environment.operations.reSendEdiFile, { shipmentEventId: activityId});
  }
}
